
import {defineComponent} from "vue";
import {Exception} from "@/api/interfaces";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {UIStateDto} from "@/dtos/UIStateDto";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import {useToast} from "vue-toastification";
import {CatalogProductsRestService} from "@/services/rest/cpc-mgmt/CatalogProductsRestService";
import {
  ProductBackInStockNotificationRequestRestDto,
  ProductBackInStockNotificationRequestResultsRestDto
} from "@/api/pharma-cpc-product-mgmt/models";
import BaseCardBody from "@/components/UI/Bootstrap/Card/BaseCardBody.vue";
import BaseCardHeader from "@/components/UI/Bootstrap/Card/BaseCardHeader.vue";
import BaseCard from "@/components/UI/Bootstrap/Card/BaseCard.vue";
import {AbilityContext} from "@/context/AbilityContext";
import {AuthContext} from "@/context/AuthContext";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import BasePlaceholderTable from "@/components/UI/Bootstrap/BasePlaceholderTable.vue";
import {ref} from "vue";

export default defineComponent({
  name: "BackInStockNotifications",

  components: {
    BasePlaceholderTable,
    InputCheckboxBoolean, BaseCard, BaseCardHeader, BaseCardBody},
  props: {
    productCode: {
      type: String,
      required: true
    }
  },
  data: () => ({
    exceptions: [] as Exception[],
    componentUI: UIStateDto.createWithDefaults(),
    sliderErrors: ref([]),
    onlyOpen: true,
    notificationRequests: null as ProductBackInStockNotificationRequestResultsRestDto | null,
    toaster: useToast(),
  }),
  mounted() {
    this.reloadContent();
  },
  computed: {
    AbilityContext() {
      return AbilityContext
    },
    AuthContext() {
      return AuthContext
    },
    notificationRequestsToDisplay(): ProductBackInStockNotificationRequestRestDto[] {
      if (!this.notificationRequests?.results?.length) {
        return [];
      }

      if (!this.onlyOpen) {
        return this.notificationRequests.results;
      }

      return this.notificationRequests.results.filter(
        (notificationRequest: ProductBackInStockNotificationRequestRestDto) => notificationRequest.open
      );
    }
  },
  methods: {
    async reloadContent() {
      this.componentUI
        .setNotReady()
        .clearError();

      try {
        this.notificationRequests = await CatalogProductsRestService.getInstance().findProductBackInStockNotificationRequests(this.productCode);
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.componentUI.setReady();
      }
    },
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
        .create()
        .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.componentUI as UIStateDto))
        .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.componentUI as UIStateDto))
        .catch(exceptions, true);
    }
  },
});
